import React from 'react';
import PropTypes from 'prop-types';
import BaseIcon from '../../utils/BaseIcon';

const TickSystemIcon = props => {
  const iconFill = props.fill || 'currentColor';
  return (
    <BaseIcon {...props}>
      <path fill={iconFill} fillRule="nonzero" d="M1.282 11.836a.75.75 0 00-1.117 1L7.841 21.4a.75.75 0 001.133-.018L23.609 3.94a.75.75 0 10-1.149-.964L8.38 19.756l-7.098-7.92z"/>
    </BaseIcon>
  );
};

TickSystemIcon.displayName = 'TickSystemIcon';

TickSystemIcon.propTypes = {
  theme: PropTypes.object,
  size: PropTypes.oneOfType([PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", "xxl", "xxxl"]), PropTypes.number]),
  fill: PropTypes.string
}

TickSystemIcon.defaultProps = {
  size: 24
};

TickSystemIcon.displayName = 'TickSystemIcon';
TickSystemIcon.iconName = 'Tick';

export default TickSystemIcon;
